import { useCallback, useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { adminPost } from "./adminApi";
import { consoleColors, primaryButtonSx } from "./consoleTheme";

export default function BusinessTypes() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ id: "", name: "" });
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const result = await adminPost("BUSINESS_LIST");
    if (result.status === "200") setRows(result.data?.rows || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setSaving(true);
    try {
      const result = await adminPost("BUSINESS_SAVE", form);
      if (result.status === "200") {
        toast.success(result.data?.message || "Saved");
        setOpen(false);
        load();
      } else toast.info(result.status_message || result.data?.error || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  const toggle = async (row) => {
    const result = await adminPost("BUSINESS_STATUS", { id: row.id, status: row.status === "1" ? "0" : "1" });
    if (result.status === "200") {
      toast.success(result.data?.message);
      load();
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, gap: 1, flexWrap: "wrap" }}>
        <Typography sx={{ color: consoleColors.muted, fontSize: 14 }}>Business types appear in the store dropdown.</Typography>
        <Button variant="contained" sx={primaryButtonSx} onClick={() => { setForm({ id: "", name: "" }); setOpen(true); }}>Add business type</Button>
      </Box>
      <Box sx={{ display: "grid", gap: 1 }}>
        {rows.map((row) => (
          <Box key={row.id} sx={{ background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2, p: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ flex: 1, fontWeight: 650 }}>{row.name}</Typography>
            <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>{row.status === "1" ? "Enabled" : "Disabled"}</Typography>
            <Button size="small" sx={{ textTransform: "none" }} onClick={() => { setForm({ id: row.id, name: row.name }); setOpen(true); }}>Edit</Button>
            <Button size="small" sx={{ textTransform: "none" }} onClick={() => toggle(row)}>{row.status === "1" ? "Disable" : "Enable"}</Button>
          </Box>
        ))}
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{form.id ? "Edit business type" : "Add business type"}</DialogTitle>
        <DialogContent>
          <TextField label="Name" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} sx={{ mt: 1 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button variant="contained" sx={primaryButtonSx} disabled={saving} onClick={save}>{saving ? "Saving..." : "Save"}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
